import React, { useEffect, useState } from 'react';
import Aos from 'aos';
import Modal from './Modal';
import {Projects} from '../data';

const Work = () => {
  const [work, setWork] = useState(null);
  const [openModal, setOpenModal] = useState(false)
  const [visible, setVisible] = useState(3)
  const [selectedType, setSelectedType] = useState(null);

  useEffect(()=>{
    Aos.init({duration:2000})
  }, []);
 //see more projects
const seeMore = ()=>{
  setVisible((prev)=> prev + 3)
}

//filter type of projects
const handleFilterClick = (type) => {
  setSelectedType(type);
};

const filteredWork = Projects.filter((work)=>{
  if (!selectedType) {
    return true;
  }
  return work.type === selectedType;
});

  return (
    <div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
      <Modal openModal={openModal} setOpenModal={setOpenModal} work={work}/>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
            Projects
          </p>
          <p className='py-6 ml-2 text-xl'>Check out some of my recent projects</p>
          <button onClick={()=> setSelectedType('')} className='m-1 mr-3 border-white hover:bg-pink-600 hover:text-white hover:border-pink-600 border px-5 py-1'>All</button>
          <button onClick={()=> handleFilterClick('full')} className='m-1 mr-3 border-white hover:bg-pink-600 hover:text-white hover:border-pink-600 border px-5 py-1'>Full Stack</button>
          <button onClick={()=> handleFilterClick('ui')} className='m-1 border-white hover:bg-pink-600 hover:text-white hover:border-pink-600 border px-5 py-1'>UI Design</button>
        </div>
        {/* Container */}
        <div data-aos="fade-right" className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
            {/* Grid Item */}
            {Projects && (
              filteredWork.slice(0, visible).map((work, key)=>(
                <div style={{ backgroundImage: `url(${work.images[0]})` }} key={key}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                {/* Hover Effects */}
                    <div className='opacity-0 text-center group-hover:opacity-100'>
                      <span className='text-2xl font-bold text-white tracking-wider'>
                        {work.title}
                      </span>
                      <div className='pt-8 text-center flex flex-col items-center'>
                          <button onClick={() => {setOpenModal(true); setWork(work)}} className='text-center w-[200px] rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                            Preview
                          </button>
                          {work.url && <a href={work.url} className='rounded-lg px-4 py-3 m-2 bg-white w-[200px] text-gray-700 font-bold text-lg'>Code</a>}
                      </div>
                    </div>
                </div>
              ))
            )}
          </div>
          {Projects.length > 3 && visible < Projects.length  && <p className='text-pink-600 my-3 underline cursor-pointer text-right' onClick={seeMore}>See more</p>}
      </div>
    </div>
  );
};

export default Work;